import { FileAttachment } from "./file-attachment.model";

export class User {
    UserId: number = 0;
    Email: string = '';
    FirstName: string = '';
    LastName: string = '';
    FullName: string = '';
    UserTypeId: number = 0;
   
    UserTypes: any = {
        InActive: false,
        UserType: 'Employee',
        UserTypeId: 1
    };
    ContactNumber: number;
    Designation: string;
    DepartmentName: string;
    UserTypeName: string ='' ;
    ContractNumber: string='';
}
export class LogInInfo {
    UserId: number;
    LogInDateTime: Date;
    LogOutDateTime: Date;
    IpAddress: string;
    UserLogInInformationId: number;
}
export class UserLogInActivityDetails {
    ModuleName: string;
    SourceId: number;
    UserId: number;
    ActivityDate: Date;
    IpAddress: string;
    UserLogInActivity: UserLogInActivity[] = [];
}
export class UserLogInActivity {
    FieldName: string='';
    OldValue: any='';
    NewValue: any='';
}
export class UserPermissionParameters
    {
        public  UserId :number;
        public  ModuleId :number;
        public  UnitId :number;
    }
 export class DocumentHeapModel
    {
        public  SourceId :string;
        public CompanyName :string;

        public ModuleName :string;

        public  IsClosureReportDocument :boolean;
        public fileAttachments :FileAttachment[]=[];
    }

